import * as angular from 'angular';
import { NextTermPlanningModule } from './dashboards/credit-gaps/next-term-planning/next-term-planning.module';

import nvSharedServicesModule from '../shared/services/nv.shared.services.module';
import nvSorterColumnModule from '../shared/sorter-column/nv.sorterColumn.module';
import { CreditGapsTransferWizardModule } from './dashboards/credit-gaps/credit-gaps-transfer-wizard/credit-gaps-transfer-wizard.module';
import { CreditGapsWizardModule } from './dashboards/credit-gaps/credit-gaps-wizard/credit-gaps-wizard.module';
// tslint:disable-next-line:max-line-length
import { CourseDiffsAndGapPlansTableModule } from './dashboards/credit-gaps/program-changes-and-gap-plans/course-diffs-and-gap-plans-table/course-diffs-and-gap-plans.module';
import { GradPlanningWizardTransferModule } from './dashboards/grad-planning/grad-planning-wizard-transfer/grad-planning-wizard-transfer.module';
import { GradPlanningWizardModule } from './dashboards/grad-planning/grad-planning-wizard/grad-planning-wizard.module';
// tslint:disable-next-line:max-line-length
import { RegentsPlanningWizardTransferModule } from './dashboards/regents/regents-planning-wizard-transfer/regents-planning-wizard-transfer.module';
import { RegentsPlanningWizardModule } from './dashboards/regents/regents-planning-wizard/regents-planning-wizard.module';
import { RegentsPrepWizardTransferModule } from './dashboards/regents/regents-prep-wizards/regents-prep-wizard-transfer/regents-prep-wizard-transfer.module';
import { RegentsPrepWizardModule } from './dashboards/regents/regents-prep-wizards/regents-prep-wizard/regents-prep-wizard.module';
import { SdcFluxModule } from './flux/sdc-flux.module';
import { SdcStateModule } from './sdc-state/sdc-state.module';
import { SdcToolbarMenuComponent } from './sdc-toolbar-menu/sdc-toolbar-menu.component';

export default angular
  .module('nv.sdcModule', [
    nvSharedServicesModule,
    nvSorterColumnModule,

    RegentsPrepWizardModule,
    RegentsPrepWizardTransferModule,

    RegentsPlanningWizardModule,
    RegentsPlanningWizardTransferModule,

    GradPlanningWizardModule,
    GradPlanningWizardTransferModule,

    CreditGapsWizardModule,
    CreditGapsTransferWizardModule,

    CourseDiffsAndGapPlansTableModule,
    SdcFluxModule,
    SdcStateModule,
    'ui.router',
    'nv.shared.error-handling',
    'nv.shared.modals',
    'nv.shared',
    'nv.shared.background-job-ui',
    NextTermPlanningModule,
  ])
  .component('sdcToolbarMenu', SdcToolbarMenuComponent).name;
